



























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import FileService from "@/services/FileService";

@Component({
  components: {}
})
export default class TagsVoew extends Vue {
  private fs = new FileService();
  private tags = null;
  private mounted() {
    this.fs.getTags().then(response => {
      this.tags = response.data;
    });
  }

  private goToTag(tag: string) {
    this.$router.push("/search?query=tag:" + tag);
  }
}
